import {GetDormantMembersRequest, DormantMember} from 'supporter';
import {api} from '@/api';
import {ActionContext} from 'vuex';

interface DormantMemberState {
  dormantMembers: DormantMember[];
  dormantLen: number;
}

export default {
  namespaced: true,
  state: {
    dormantMembers: null,
    dormantLen: 0
  },
  actions: {
    async fetchDormantMembers({commit}: ActionContext<DormantMemberState, any>, request: GetDormantMembersRequest): Promise<any> {
      commit('SET_DORMANT_MEMBER', null);
      commit('SET_DORMANT_MEMBER_CNT', 0);

      api.getDormantMembers(request).then((ret): void => {
        commit('SET_DORMANT_MEMBER', ret!.data!.contents);
        commit('SET_DORMANT_MEMBER_CNT', ret!.data!.totalCount);
      });
    }
  },
  mutations: {
    SET_DORMANT_MEMBER(state: DormantMemberState, members: DormantMember[]): void {
      state.dormantMembers = members;
    },
    SET_DORMANT_MEMBER_CNT(state: DormantMemberState, len: number): void {
      state.dormantLen = len;
    }
  }
};
